import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FALLBACK = { italy_fee: 6.3, italy_promos: [{ min: 200, pct: 100 }], eu_fee: 19.3, eu_promos: [{ min: 500, pct: 100 }], cod_fee: 3 };
let cache = null;
let pending = null;
const listeners = new Set();

export const refreshShippingConfig = () => {
  pending = api.get("/shipping/config").then((r) => { cache = r.data; listeners.forEach((l) => l(cache)); return cache; }).catch(() => FALLBACK);
  return pending;
};

export const useShippingConfig = () => {
  const [cfg, setCfg] = useState(cache || FALLBACK);
  useEffect(() => {
    listeners.add(setCfg);
    if (!cache && !pending) refreshShippingConfig();
    return () => { listeners.delete(setCfg); };
  }, []);
  return cfg;
};

export const euro = (n) => `${Number(n).toFixed(2).replace(".", ",")} €`;

export const shipFee = (c, zone, subtotal) => {
  const best = Math.max(0, ...(c[`${zone}_promos`] || []).filter((p) => subtotal >= p.min).map((p) => p.pct));
  return Math.round(c[`${zone}_fee`] * (100 - best)) / 100;
};

export const freeOver = (c, zone) => (c[`${zone}_promos`] || []).filter((p) => p.pct === 100).map((p) => p.min).sort((a, b) => a - b)[0];

export const promoText = (c, zone) => (c[`${zone}_promos`] || []).map((p) => (p.pct === 100 ? `gratis sopra ${euro(p.min)}` : `-${p.pct}% sopra ${euro(p.min)}`)).join(" · ");

export const promoSummary = (c) => [["Italia", "italy"], ["UE", "eu"]].map(([l, z]) => (promoText(c, z) ? `${l}: ${promoText(c, z)}` : "")).filter(Boolean).join(" · ") || "Spedizione con corriere tracciato";
